import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getLongestDeletedActivities';

export const getLongestDeletedActivities = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
